import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import firebaseConfig from '../../firebase-applet-config.json';

// No domínio oficial, o login do Google aparece como "flowaes.com" (o servidor
// repassa /__/auth/* para o Firebase). Em outros endereços, usa o padrão.
const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';
const OFFICIAL_HOSTS = ['flowaes.com', 'www.flowaes.com'];
const authDomain = OFFICIAL_HOSTS.includes(currentHost) ? currentHost : firebaseConfig.authDomain;

const app = initializeApp({ ...firebaseConfig, authDomain });
export const db = initializeFirestore(app, { experimentalForceLongPolling: true }, (firebaseConfig as any).firestoreDatabaseId); // CRITICAL: The app will break without this line
export const auth = getAuth(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');

export const loginWithGoogle = async () => {
  try {
    await signInWithPopup(auth, googleProvider);
  } catch (error: any) {
    console.error("Error logging in with Google", error);
    
    // Check for unauthorized-domain error
    if (error.code === 'auth/unauthorized-domain') {
      const currentHost = window.location.hostname;
      alert(
        `Erro: Domínio Não Autorizado.\n\n` +
        `Este domínio (${currentHost}) precisa ser adicionado na lista de "Domínios Autorizados" no Console do Firebase (Authentication -> Settings -> Authorized domains).\n\n` +
        `Certifique-se de adicionar:\n` +
        `1. ${currentHost}\n` +
        `2. ais-pre-ockziirfaa6jjnwyggx6as-488547845735.us-west2.run.app`
      );
    } else if (error.code === 'auth/network-request-failed') {
      alert("Erro de rede ao fazer login. Isso geralmente ocorre porque o navegador está bloqueando cookies de terceiros no modo de visualização (iframe). Por favor, abra o aplicativo em uma nova guia (usando o botão no canto superior direito) para fazer login.");
    } else {
      alert(`Erro no login: ${error.message}`);
    }
  }
};

export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Error logging out", error);
  }
};
